import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import create from 'zustand';
import { FieldValue } from '../components/common/presentation';
import { Auto } from './controls';
import { WorksheetSummary } from './domain';
import { createStatusApi } from './status';
import { orange } from './theme';
import {
  transitionApi,
  TransitionForm,
  transitionListForm,
  TransitionStore,
} from './transition-api';
import React from 'react';

export function TransitionList(form: TransitionForm) {
  const { action } = form.controls;
  return <Auto {...action} />;
}

export const transitionDialogueStore = create<{
  summary: WorksheetSummary;
  open: boolean;
  transitionComplete?: (summary: WorksheetSummary) => void;
}>(() => ({
  summary: null,
  open: false,
}));

const status = createStatusApi();
const transition: TransitionStore = transitionApi({
  status,
});

export function TransitionDialogue() {
  const error = status((s) => s.status);
  const [loading, setLoading] = useState(false);
  const summary: WorksheetSummary = transitionDialogueStore((s) => s.summary);
  const actions = summary?.stateInfo?.actions;

  const open = transitionDialogueStore((s) => s.open);
  if (open) {
    transition.getState().setWorksheet(summary);
  }
  const form: TransitionForm = useRef(
    transitionListForm(transition, {
      onValid: () => {
        status.setState({ status: null });
        setLoading(true);
      },
    })
  ).current;

  transition.getState().transitionDialogueComplete = () => {
    const sum = transition.getState().worksheetState;
    transitionDialogueStore.setState({ summary: sum });
    setLoading(false);
    const fn = transitionDialogueStore.getState().transitionComplete;
    if (fn) {
      fn(sum);
    }
  };
  form.refreshActions();

  const state = transition((s) => s.worksheetState)?.stateInfo?.name;

  useEffect(() => {
    if (summary && open) {
      transition.getState().setWorksheet(summary);
    }

    return status.subscribe(
      (v) => setLoading(!v),
      (s) => s.status
    );
  }, []);

  const close = () => transitionDialogueStore.setState({ open: false });
  return (
    <Dialog open={open} maxWidth={false} onClose={close}>
      <DialogTitle style={{ paddingBottom: 0 }}>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item>Transition Worksheet</Grid>
          {loading && (
            <Grid item>
              <CircularProgress size={14} style={{ paddingTop: 4 }} />
            </Grid>
          )}
        </Grid>
      </DialogTitle>
      <DialogContent style={{ width: 250 }}>
        {actions?.length ? (
          <TransitionList {...form} />
        ) : (
          <span>No Transitions Available</span>
        )}
        {error && (
          <div style={{ color: orange, width: '100%', height: 42 }}>
            {error}
          </div>
        )}
        {state && (
          <>
            <br />
            <FieldValue row={false} label="Current State" value={state} />
          </>
        )}

        <br />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary" variant="outlined">
          {' '}
          Close{' '}
        </Button>
        <Button
          onClick={() => form.submit()}
          color="primary"
          variant="contained"
        >
          {' '}
          Transition{' '}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
